import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function RoomPage() {
  const { roomCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const roomRef = doc(db, "rooms", roomCode);

    // شنود تغییرات دیتابیس
    const unsubscribe = onSnapshot(roomRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.choice === "video") {
          navigate(`/watch/${roomCode}`);
        } else if (data.choice === "music") {
          navigate(`/video-call/${roomCode}`);
        } else if (data.choice === "game") {
          navigate(`/game/${roomCode}`);
        }
      }
    });

    // پاک‌سازی شنود وقتی کامپوننت از بین میره
    return () => unsubscribe();
  }, [roomCode, navigate]);

  const handleChoice = async (type) => {
    const roomRef = doc(db, "rooms", roomCode);
    await updateDoc(roomRef, { choice: type });
  };

  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <h2>🎬 وارد اتاق شدید: {roomCode}</h2>
      <p>یکی از گزینه‌ها را انتخاب کنید:</p>
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
        <button onClick={() => handleChoice("video")}>🎞 تماشای فیلم</button>
        <button onClick={() => handleChoice("music")}>🎵 پخش موزیک</button>
        <button onClick={() => handleChoice("game")}>🎮 بازی</button>
      </div>
    </div>
  );
}
